import axios from 'axios';

export default class ApiClient {

  constructor(options) {
    this._client = axios.create(options);
    this._authService = options.authService;
  }

  /* CRUD actions */
  seasons(id = null) {
    let url = `/v2/api/seasons`;

    if (id) url += `/${id}`;

    return this._client.get(url);
  }

  createSeason(season) {
    let url = '/v2/api/seasons';
    return this._client.post(url, season, {
      headers: {
        authorization: `Bearer ${this._getToken()}`
      }
    });
  }

  updateSeason(season) {
    let url = `/v2/api/seasons/${season.season_id}`;
    return this._client.put(url, season, {
      headers: {
        authorization: `Bearer ${this._getToken()}`
      }
    });
  }

  players(id = null) {
    let url = `/v2/api/players`;

    if (id) url += `/${id}`;

    return this._client.get(url);
  }

  createPlayer(player) {
    let url = '/v2/api/players';
    return this._client.post(url, player, {
      headers: {
        authorization: `Bearer ${this._getToken()}`
      }
    });
  }

  updatePlayer(player) {
    let url = `/v2/api/players/${player.player_id}`;
    return this._client.put(url, player, {
      headers: {
        authorization: `Bearer ${this._getToken()}`
      }
    });
  }

  weeks(season_id, week = null) {
    let url = `/v2/api/seasons/${season_id}/weeks`;

    if (week) url += `/${week}`;

    return this._client.get(url);
  }

  createWeek(season_id, week) {
    let url = `/v2/api/seasons/${season_id}/weeks`;
    return this._client.post(url, week, {
      headers: {
        authorization: `Bearer ${this._getToken()}`
      }
    });
  }

  updateWeek(season_id, week) {
    let url = `/v2/api/seasons/${season_id}/weeks/${week.week}`;
    return this._client.put(url, week, {
      headers: {
        authorization: `Bearer ${this._getToken()}`
      }
    });
  }

  /* Stats Methods */
  points(season_id) {
    return this._client.get(`/v2/api/seasons/${season_id}/standings`);
  }

  topTen(season_id) {
    return this._client.get(`/v2/api/seasons/${season_id}/top10`);
  }

  holes(season_id) {
    return this._client.get(`/v2/api/seasons/${season_id}/holes`);
  }

  playerStats(season_id, player_id) {
    return this._client.get(`/v2/api/seasons/${season_id}/players/${player_id}/stats`);
  }

  _getToken() {
    return this._authService.getAccessToken();
  }

  static install(Vue, options) {
    Vue.apiClient = Vue.prototype.$apiClient = new ApiClient(options);
  }
}
